import { render, staticRenderFns } from "./welcome-widget-container.vue?vue&type=template&id=80189bdc&scoped=true"
import script from "./welcome-widget-container.vue?vue&type=script&lang=ts"
export * from "./welcome-widget-container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80189bdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80189bdc')) {
      api.createRecord('80189bdc', component.options)
    } else {
      api.reload('80189bdc', component.options)
    }
    module.hot.accept("./welcome-widget-container.vue?vue&type=template&id=80189bdc&scoped=true", function () {
      api.rerender('80189bdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/application-widget/components/welcome-widget-container.vue"
export default component.exports